export class DebounceThrottleUtils {
    private _throttleEnabled: boolean = false;
    private _debounceTimerId;

    /**
    * This function is used to call the passed function once and 
    * prevent the subsequent calls until the specified throttle 
    * time has elapsed.
    *
    * @param {any} func 
    * @param {object} callingInstance 
    * @param {number} throttleTime
    * @return reference to throttle function
    */
    public throttleFunction<Params extends any[]>(
        func: (...args: Params) => any,
        callingInstance: object,
        throttleTime: number = 2000,
      ): (...args: Params) => void {
        return (...args: Params) => {
          if(!this._throttleEnabled) {
            this._throttleEnabled = true;
            setTimeout(()=> {
              this._throttleEnabled = false 
            }, throttleTime);
            func.apply(callingInstance, args);
          }
        }
    }

   /**
    * This function delays the execution of the calling function
    * within the debounce time interval
    *
    * @param {any} func 
    * @param {object} callingInstance 
    * @param {number} debounceTime
    * @return reference to debounce function
    */
    public debounceFunction<Params extends any[]>(
      func: (...args: Params) => any,
      callingInstance: object,
      debounceTime: number = 1000,
    ): (...args: Params) => void {
      return (...args: Params) => {
          clearTimeout(this._debounceTimerId);
          this._debounceTimerId = setTimeout(function () {
              func.apply(callingInstance, args);
          }, debounceTime);
      };
    }
}
